module.exports = __webpack_public_path__ + "img/胃肠癌.b09bd874.png";